export default __webpack_public_path__ + "static/media/thumbnail0.55b584b4.jpg";